import { useState, useEffect } from 'react';
import api from '../api/client';
import MetricCard from '../components/MetricCard';
import DateFilter from '../components/DateFilter';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Dashboard() {
  const [period, setPeriod] = useState('month');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/dashboard?period=${period}`)
      .then((res) => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [period]);

  if (loading) return <div>Cargando...</div>;
  if (!data) return <div>Error al cargar dashboard</div>;

  const chartData = {
    labels: ['Enviados', 'Entregados', 'Leidos', 'Clics', 'Fallidos'],
    datasets: [{
      label: 'Mensajes',
      data: [data.totalSent, data.totalDelivered, data.totalRead, data.totalClicks, data.totalFailed],
      backgroundColor: ['#3498db', '#2ecc71', '#4ecca3', '#f39c12', '#e74c3c'],
      borderRadius: 4,
    }],
  };

  return (
    <div>
      <h1 style={{ marginBottom: 4 }}>Dashboard</h1>
      <DateFilter selected={period} onChange={setPeriod} />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 30 }}>
        <MetricCard title="Enviados" value={data.totalSent} />
        <MetricCard title="Entregados" value={data.totalDelivered} />
        <MetricCard title="Leidos" value={data.totalRead} subtitle={`Open rate: ${data.openRate}%`} />
        <MetricCard title="Clics" value={data.totalClicks} subtitle={`Click rate: ${data.clickRate}%`} color="#f39c12" />
        <MetricCard title="Revenue" value={`$${Number(data.totalRevenue).toLocaleString()}`} color="#2ecc71" />
        <MetricCard title="Carritos recuperados" value={data.cartsRecovered} color="#3498db" />
      </div>

      <div style={{ background: '#fff', borderRadius: 8, padding: 24, maxWidth: 700 }}>
        <h3 style={{ marginTop: 0 }}>Resumen de mensajes</h3>
        <Bar data={chartData} options={{ responsive: true, plugins: { legend: { display: false } } }} />
      </div>

      {data.topCampaigns?.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, marginTop: 20 }}>
          <h3 style={{ marginTop: 0 }}>Campanas recientes</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                <th style={{ padding: '8px 0' }}>Nombre</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Enviada</th>
              </tr>
            </thead>
            <tbody>
              {data.topCampaigns.map((c) => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '8px 0' }}>{c.nombre}</td>
                  <td>{c.tipo}</td>
                  <td>{c.estado}</td>
                  <td>{c.sent_at ? new Date(c.sent_at).toLocaleDateString() : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
